import { useQueryClient } from "@tanstack/react-query"
import {
  CheckClientPractitionerUniquenessDocument,
  CheckClientPractitionerUniquenessQuery,
  CheckClientPractitionerUniquenessQueryVariables,
  GetDataFromInviteCodeDocument,
  GetDataFromInviteCodeQuery,
  GetDataFromInviteCodeQueryVariables,
  useAddClientMutation,
} from "../generated/graphql"
import { Query } from "../utils/constants"
import { useGraphQLClient } from "./useGraphQLClient"
import { useApi } from "../utils/API"

export const useInviteCode = () => {
  const queryClient = useQueryClient()
  const graphqlClient = useGraphQLClient()
  const { mutateAsync: addClient } = useAddClientMutation(graphqlClient, {
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [Query.GET_USERS_BY_PRACTITIONER],
      }),
  })
  const api = useApi()

  return {
    addClient: async (code: string, practitioner_id: string) => {
      const response = await addClient({ code, practitioner_id })

      if (response.update_invite_codes?.returning?.[0]) {
        api.assignDefaultUserFeatureFlags(code, false)
      }
      return response?.update_invite_codes?.returning?.[0]
    },
    checkIfClientAssigned: async (
      code: string,
      practitionerId: string
    ): Promise<"invalid" | "assigned" | "unassigned"> => {
      const clientIdResponse = await graphqlClient.request<
        GetDataFromInviteCodeQuery,
        GetDataFromInviteCodeQueryVariables
      >(GetDataFromInviteCodeDocument, {
        code,
      })
      const clientIds = clientIdResponse?.invite_codes
      if (!clientIds || clientIds.length === 0) {
        return "invalid"
      }
      const clientId = clientIds[0].client_id
      const uniquenessResponse = await graphqlClient.request<
        CheckClientPractitionerUniquenessQuery,
        CheckClientPractitionerUniquenessQueryVariables
      >(CheckClientPractitionerUniquenessDocument, {
        clientId,
        practitionerId,
      })
      return uniquenessResponse.invite_codes.length > 0
        ? "assigned"
        : "unassigned"
    },
  }
}
